import React, { useEffect, useState } from "react";

const dificulte = ["Ușor", "Mediu", "Greu"];

export default function CreeazaCursuri() {
  const [titlu, setTitlu] = useState("");
  const [dificultate, setDificultate] = useState(dificulte[0]);
  const [timpEstimativ, setTimpEstimativ] = useState("");
  const [slideuri, setSlideuri] = useState([""]);
  const [intrebari, setIntrebari] = useState([
    { intrebare: "", varianta_a: "", varianta_b: "", varianta_c: "", varianta_d: "", varianta_e: "", raspuns_corect: "a" },
  ]);
  const [mesaj, setMesaj] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Stilizări neumorphism inline pentru demo rapid (cel mai bine e cu CSS dedicat, vezi secțiunea 2)
  const cardStyle = {
    background: "#f3f6fd",
    borderRadius: "20px",
    boxShadow: "6px 6px 18px #e3e6ee, -6px -6px 20px #f9faff",
    padding: "32px",
    maxWidth: "480px",
    margin: "40px auto",
  };

  const inputStyle = {
    border: "none",
    borderRadius: "12px",
    padding: "12px",
    boxShadow: "inset 3px 3px 8px #e3e6ee, inset -3px -3px 8px #fff",
    background: "#f7faff",
    fontSize: "1em",
    marginBottom: "12px",
    width: "100%"
  };

  const labelStyle = { marginBottom: 6, marginTop: 10, color: "#33418c", fontWeight: "600" };
  const btnStyle = {
    border: "none",
    borderRadius: "12px",
    background: "#285be8",
    color: "#fff",
    fontWeight: "700",
    boxShadow: "4px 4px 20px #dae3fa, -4px -4px 20px #faffff",
    padding: "14px 0",
    width: "100%",
    fontSize: "1.08em",
    marginTop: 20
  };

  const sectionTitle = { color: "#01358D", fontWeight: 700, marginBottom: 28, marginTop: 0 };

  // Slide utils
  const updateSlide = (i, val) => {
    const s = [...slideuri];
    s[i] = val;
    setSlideuri(s);
  };
  const addSlide = () => setSlideuri([...slideuri, ""]);
  const removeSlide = (i) => setSlideuri(slideuri.filter((_, index) => index !== i));

  // Întrebări
  const updateIntrebare = (i, field, val) => {
    const it = [...intrebari];
    it[i][field] = val;
    setIntrebari(it);
  };
  const addIntrebare = () => setIntrebari([...intrebari, { intrebare: "", varianta_a: "", varianta_b: "", varianta_c: "", varianta_d: "", varianta_e: "", raspuns_corect: "a" }]);
  const removeIntrebare = (i) => setIntrebari(intrebari.filter((_, index) => index !== i));

  const trimiteCurs = async () => {
    setError(""); setMesaj("");
    if (!titlu || !dificultate || !timpEstimativ) {
      setError("Completați toate câmpurile de bază.");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch("https://prdp-api.suport-949.workers.dev/api/cursuri", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: "Bearer unwantedtok" },
        body: JSON.stringify({ titlu, dificultate, timp_estimativ: timpEstimativ, slideuri, intrebari }),
      });
      const data = await res.json();
      if (data.success) {
        setMesaj("Curs creat cu succes!");
        setTitlu(""); setDificultate(dificulte[0]); setTimpEstimativ("");
        setSlideuri([""]);
        setIntrebari([{ intrebare: "", varianta_a: "", varianta_b: "", varianta_c: "", varianta_d: "", varianta_e: "", raspuns_corect: "a" }]);
      } else {
        setError(data.error || "Eroare la crearea cursului.");
      }
    } catch {
      setError("Eroare de rețea sau server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={cardStyle}>
      <h2 style={sectionTitle}>Creează curs nou</h2>
      {error && <div style={{color: "#e12424", marginBottom: 10}}>{error}</div>}
      {mesaj && <div style={{color: "#18891b", marginBottom: 10}}>{mesaj}</div>}

      <div>
        <label style={labelStyle}>Titlu curs</label>
        <input style={inputStyle} value={titlu} onChange={e => setTitlu(e.target.value)} />
      </div>
      <div>
        <label style={labelStyle}>Dificultate</label>
        <select style={inputStyle} value={dificultate} onChange={e => setDificultate(e.target.value)}>
          {dificulte.map(d => <option key={d} value={d}>{d}</option>)}
        </select>
      </div>
      <div>
        <label style={labelStyle}>Timp estimat (ex: 2-3 ore)</label>
        <input style={inputStyle} value={timpEstimativ} onChange={e => setTimpEstimativ(e.target.value)} />
      </div>

      {/* Slideuri */}
      <div>
        <label style={labelStyle}>Slide-uri</label>
        {slideuri.map((slide, i) => (
          <div key={i} style={{marginBottom: 10, position: "relative"}}>
            <textarea style={{...inputStyle, minHeight: 55}} value={slide} onChange={e => updateSlide(i, e.target.value)} />
            <button style={{
              position: "absolute", right: 0, bottom: 0, border: 0, background: "#e64040", color: "#fff",
              borderRadius: "0 0 12px 0", padding: "2px 10px", fontWeight: 700, boxShadow: "2px 2px 8px #f3f6fd"
            }}
            disabled={slideuri.length === 1}
            onClick={() => removeSlide(i)}>×</button>
          </div>
        ))}
        <button style={{
          background: "#285be8", color: "#fff", border: 0, borderRadius: 8,
          padding: "5px 20px", marginTop: 0, boxShadow: "2px 2px 8px #e3e6ee"
        }} type="button" onClick={addSlide}>
          + Adaugă slide
        </button>
      </div>

      {/* Intrebari grila */}
      <div>
        <label style={labelStyle}>Întrebări grilă</label>
        {intrebari.map((it, i) => (
          <div key={i} style={{
            background: "#f7faff", borderRadius: 12, boxShadow: "inset 2px 2px 6px #e3e6ee, inset -2px -2px 6px #fff",
            padding: 10, marginBottom: 16
          }}>
            <textarea style={{...inputStyle, minHeight: 35}} placeholder="Întrebare" value={it.intrebare} onChange={e => updateIntrebare(i, "intrebare", e.target.value)} />
            {["a", "b", "c", "d", "e"].map(opt => (
              <div key={opt} style={{display: "flex", alignItems: "center", marginBottom: 4}}>
                <input
                  type="radio"
                  name={`raspuns_corect_${i}`}
                  checked={it.raspuns_corect === opt}
                  onChange={() => updateIntrebare(i, "raspuns_corect", opt)}
                  style={{marginRight: 5}}
                />
                <span style={{minWidth: 60}}>Opțiunea {opt.toUpperCase()}:</span>
                {(opt !== "e" || it[`varianta_${opt}`]) && (
                  <input
                    style={{...inputStyle, width: "60%", marginBottom: 0}}
                    type="text"
                    value={it[`varianta_${opt}`]}
                    onChange={e => updateIntrebare(i, `varianta_${opt}`, e.target.value)}
                  />
                )}
              </div>
            ))}
            <button type="button" style={{
              border: 0, borderRadius: 8, background: "#e64040", color: "#fff",
              margin: "8px 0 0 0", padding: "3px 12px", fontWeight: 700, boxShadow: "2px 2px 8px #f3f6fd"
            }}
            onClick={() => removeIntrebare(i)} disabled={intrebari.length === 1}>
              Șterge întrebare
            </button>
          </div>
        ))}
        <button style={{
          background: "#285be8", color: "#fff", border: 0, borderRadius: 8,
          padding: "5px 20px", boxShadow: "2px 2px 8px #e3e6ee"
        }} type="button" onClick={addIntrebare}>
          + Adaugă întrebare
        </button>
      </div>
      <button type="button" style={btnStyle} onClick={trimiteCurs} disabled={loading}>
        {loading ? "Salvează..." : "Salvează curs"}
      </button>
    </div>
  );
}
